import React, { JSX } from 'react';
import { PostType } from '@/@types/post';
import Style from './ArchivePosts.module.scss';
import Post from './Post';

type Props = {
  posts: PostType[];
};

const ArchivePosts: React.FC<Props> = ({ posts }): JSX.Element => {
  return (
    <div>
      {posts.length ? (
        <div className={Style.thead}>
          <div className={Style.date}>日付</div>
          <div className={Style.category}>カテゴリー</div>
          <div className={Style.title}>件名</div>
        </div>
      ) : null}
      {posts.map((post) => {
        return <Post key={post.url} url={post.url} date={post.event_start} eventType={post.type} title={post.title} />;
      })}
    </div>
  );
};

export default ArchivePosts;
